import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rateLabel: {
    description: 'rateAndRefresh.label',
    defaultMessage: 'Rate',
    id: 'whDfcJ',
  },
  rateProvidedLabel: {
    description: 'rateAndRefresh.label',
    defaultMessage: 'Provided',
    id: 'deDIsB',
  },
  rateErrorLabel: {
    description: 'label to place to the right of the icon',
    defaultMessage: 'Rate Error',
    id: 'gYsFkJ',
  },
  rateWarningLabel: {
    description: 'label to place to the right of the icon',
    defaultMessage: 'Rate Alert',
    id: 'ki2frA',
  },
  thirdPartyBillingTooltip: {
    defaultMessage: 'Rates are unknown for third party shipping accounts.',
    description: 'No rates for third party accounts tooltip',
    id: '+BVC52',
  },
});
